import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';

import { Référentiel } from '../models/référentiel.model';
import { ReferentielState } from './referentiel.state';

export function avecSélecteursRéférentiels<_>() {
  return signalStoreFeature(
    {
      state: type<ReferentielState & EntityState<Référentiel>>(),
      props: type<EntityProps<Référentiel> & { selectedEntity: Signal<Référentiel | null> }>(),
    },
    // Filtres
    withComputed(({ entities, filtres, sort }) => ({
      getFilteredReferentiels: computed(() => {
        let r = [...entities()];
        const filtresActifs = filtres();
        if (filtresActifs) {
          if (filtresActifs.equipeResponsable) {
            r = r.filter((x) => x.equipeResponsable === filtresActifs.equipeResponsable);
          }
          if (filtresActifs.idMetier) {
            r = r.filter((x) => x.id === filtresActifs.idMetier);
          }
        }
        const { nom, direction } = sort();
        let sortFn = (r1: Référentiel, r2: Référentiel) =>
          (r1 as any)[nom].toString().localeCompare((r2 as any)[nom].toString());
        if (direction === '-') {
          sortFn = (r1: Référentiel, r2: Référentiel) =>
            (r2 as any)[nom].toString().localeCompare((r1 as any)[nom].toString());
        }
        r.sort(sortFn);
        return r;
      }),
      referentielsActifs: computed(() => entities().filter((x) => x.estActif)),
    })),
    // Pagination
    withComputed(({ paginator, getFilteredReferentiels }) => ({
      getPaginated: computed(() =>
        getFilteredReferentiels().slice(
          (paginator.pageNb() - 1) * paginator.pageSize(),
          paginator.pageNb() * paginator.pageSize(),
        ),
      ),
      totalPageNb: computed(() => Math.ceil(getFilteredReferentiels().length / paginator.pageSize()) || 1),
      firstItemNumber: computed(() => {
        if (getFilteredReferentiels().length === 0) {
          return 0;
        }
        return (paginator.pageNb() - 1) * paginator.pageSize() + 1;
      }),
      lastItemNumber: computed(() => {
        if (paginator.pageNb() === Math.ceil(getFilteredReferentiels().length / paginator.pageSize())) {
          return getFilteredReferentiels().length;
        }
        return paginator.pageNb() * paginator.pageSize();
      }),
      count: computed(() => getFilteredReferentiels().length),
    })),
  );
}
